import loadable from '@loadable/component';
import React from 'react';

import UniversalRouter from 'universal-router';

import { parseQueryString } from '@travel/utils';

import bonusProgramResolver from 'promotions/pages/BonusProgramPage/resolver';
import promotionsResolver from 'promotions/pages/DatedAdPage/resolver';

import paths from './paths';
import type { universalRouterProps } from './types';

import App from 'promotions/core/app';

export default (props: universalRouterProps) => {
  const isServer = props.isServer || false;

  const routes = [
    {
      path: '/',
      async action(context: any) {
        let children;

        try {
          children = await context.next();
        } catch (e) {
          console.error(e);
          children = null;
        }

        return (
          <App {...context} key="app">
            {children}
          </App>
        );
      },
      children: [
        {
          path: paths.top.path,
          async action(context: any) {
            const DatedAdPage = loadable(
              () =>
                import(/* webpackChunkName: "pages-DatedAdPage" */ 'promotions/pages/DatedAdPage'),
            );

            if (isServer) {
              await promotionsResolver(props, context);
            } else if (!context.skipResolver) {
              promotionsResolver(props, context);
            }

            return <DatedAdPage {...context} />;
          },
        },
        {
          path: paths.datedAd.path,
          async action(context: any) {
            const DatedAdPage = loadable(
              () =>
                import(/* webpackChunkName: "pages-DatedAdPage" */ 'promotions/pages/DatedAdPage'),
            );

            if (isServer) {
              await promotionsResolver(props, context);
            } else if (!context.skipResolver) {
              promotionsResolver(props, context);
            }

            return <DatedAdPage {...context} />;
          },
        },
        {
          path: paths.bonusProgram.path,
          async action(context: any) {
            const BonusProgramPage = loadable(
              () =>
                import(
                  /* webpackChunkName: "pages-BonusProgramPage" */ 'promotions/pages/BonusProgramPage'
                ),
            );

            if (isServer) {
              await bonusProgramResolver(props, context);
            } else if (!context.skipResolver) {
              bonusProgramResolver(props, context);
            }

            return <BonusProgramPage {...context} />;
          },
        },
        {
          // also resolve paths.notFound.path
          path: '(.*)',
          async action(context: any) {
            const ErrorPage = loadable(
              () => import(/* webpackChunkName: "pages-ErrorPage" */ 'promotions/pages/ErrorPage'),
            );
            // Please remove if you want to test the error page.
            if (process.env.NODE_ENV !== 'production') {
              props.res?.redirect('/promotions/dated-ad');
            }
            props.res?.status(400);
            return <ErrorPage />;
          },
        },
      ],
    },
  ];
  return new UniversalRouter(routes, {
    resolveRoute(context, params) {
      if (typeof context.route.action === 'function') {
        context.query = {};
        if (context.search) {
          // when redirect from omni with existing filter,
          // there will be ? added from the redirection
          const searchRegex = new RegExp('\\?$');
          const currentSearch = context.search;
          context.query = parseQueryString(
            searchRegex.test(currentSearch)
              ? currentSearch.substring(0, currentSearch.length - 1)
              : currentSearch,
          );
        }

        return context.route.action(context, params);
      }
      return undefined;
    },
  });
};
